// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1LKbw","footer":"ChangeClinic_footer__1g3p2"};